window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ui-dropdown-filter').length) {
    import('./_list-filter.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
